module.exports = __webpack_public_path__ + "img/mrBts_concept.d2324471.jpg";